var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-5"},[_c('b-btn',{staticClass:"mr-2",on:{"click":function($event){return _vm.run()}}},[_vm._v("RUN!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }